export const SupportIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M11.75 21.15a.82.82 0 0 1-.606-.247.83.83 0 0 1-.246-.61q0-.362.246-.604a.83.83 0 0 1 .606-.243h7.69V11.84q0-3.044-2.17-5.156t-5.264-2.112q-3.098 0-5.272 2.115t-2.174 5.16v5.647a.587.587 0 0 1-.601.602h-.025a2.02 2.02 0 0 1-1.472-.607 2 2 0 0 1-.612-1.468v-2.075q0-.531.266-.996t.734-.753l.057-1.127A8.7 8.7 0 0 1 3.86 7.82a9.5 9.5 0 0 1 2.002-2.612 9 9 0 0 1 2.796-1.737A9 9 0 0 1 12 2.845q1.761 0 3.333.626A9.3 9.3 0 0 1 18.13 5.2a9.1 9.1 0 0 1 2.964 5.857l.063 1.102q.468.243.734.698.265.456.265.969v2.312q0 .527-.259 1.005a1.73 1.73 0 0 1-.74.728v1.581q0 .698-.495 1.197t-1.191.5zm-2.7-7.28a.757.757 0 0 1-.77-.776q0-.33.224-.548a.76.76 0 0 1 .554-.218.74.74 0 0 1 .55.222q.22.223.22.55 0 .33-.224.55a.76.76 0 0 1-.554.22m5.892 0a.757.757 0 0 1-.77-.776q0-.33.225-.548a.76.76 0 0 1 .553-.218.74.74 0 0 1 .55.222q.22.223.22.55 0 .33-.224.55a.76.76 0 0 1-.554.22m-8.863-1.54Q5.92 9.74 7.686 7.898q1.763-1.843 4.358-1.843 2.143 0 3.723 1.414T17.697 11a7.4 7.4 0 0 1-3.972-1.178 8 8 0 0 1-2.821-3.082 7.46 7.46 0 0 1-1.699 3.41 7.77 7.77 0 0 1-3.126 2.18"
      />
    </svg>
  );
};
